import Colors from '../../../../Configs/colors';

const styles = {
  tabs: {
    '& :hover': {
      // color: colors.black1,
      opacity: 1,
    },
    '& .MuiButtonBase-root': {
      color: '#2E3C40 !important',
      fontFamily: 'Nunito Sans',
      '&.Mui-selected': {
        color: `${Colors.primary} !important`,
        textTransform: 'none !important',
        fontWeight: '600 !important',
      },
    },
    '& .Mui-focusVisible': {
      // backgroundColor: `${colors.black1} !important`,
    },
    '& .MuiTab-root': {
      textTransform: 'none !important',
      fontSize: 14,
      fontWeight: '600',
      paddingBottom: '2px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Colors.primary,
    },
  },
  root: {
    paddingBottom: 16,
    '& .info-card': {
      position: 'relative',
      background: '#FDF2ED',
      borderRadius: 8,
      boxShadow: '2px 3px 6px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.02)',
      '& .info': {
        padding: 16,
        '& .value': {
          fontSize: 24,
        },
        '& .desc': {

        },
      },
    },
    '& .request-card': {
      background: Colors.white,
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
      padding: '12px',
      overflow: 'hidden',
      border: `1px solid ${Colors.grey}`,
      borderRadius: 8,
      marginBottom: 16,
      cursor: 'pointer',
      '& .status': {
        background: '#ECF5F8',
        padding: '4px 12px',
        borderRadius: 25,

      },
    },
    '& .card-head-container': {
      padding: '8px 0 16px',
    },
    '& .card-head': {
      background: Colors.white,
      padding: 8,
      borderRadius: 8,
    },
    '& .section-progress': {
      maxHeight: '90vh',
      overflow: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
};

export default styles;
